(() => {
  'use strict';

  const marker = 'data-lrs-protected-photo';
  const optOut = '[data-lrs-allow-image-save]';
  const originals = new WeakMap();
  const protectedPhotos = new Set();
  let observer;

  const enabled = () => document.body?.dataset.lrsPhotoProtection === 'true'
    && !window.Shopify?.designMode;

  const isPhoto = image => image instanceof HTMLImageElement
    && (image.closest('#main') || image.id === 'lightbox-image')
    && !image.closest(optOut);

  function release(image) {
    if (!protectedPhotos.delete(image)) return;
    image.removeAttribute(marker);
    const draggable = originals.get(image);
    if (draggable === null) image.removeAttribute('draggable');
    else image.setAttribute('draggable', draggable);
    originals.delete(image);
  }

  function protect(image) {
    if (!enabled() || !isPhoto(image)) {
      release(image);
      return;
    }
    if (!protectedPhotos.has(image)) {
      originals.set(image, image.getAttribute('draggable'));
      protectedPhotos.add(image);
    }
    image.setAttribute(marker, '');
    image.draggable = false;
  }

  function scan(root) {
    if (root instanceof HTMLImageElement) protect(root);
    root.querySelectorAll?.('img').forEach(protect);
  }

  function stop() {
    observer?.disconnect();
    [...protectedPhotos].forEach(release);
  }

  function init(root = document) {
    if (!enabled()) {
      stop();
      return;
    }

    scan(root);
    // The gallery lives beside main; its image is also protected on initial load.
    const lightboxImage = document.querySelector('#lightbox-image');
    if (lightboxImage) protect(lightboxImage);
    [...protectedPhotos].forEach(protect);

    if (!observer) {
      observer = new MutationObserver(records => {
        if (!enabled()) {
          stop();
          return;
        }
        records.forEach(record => {
          if (record.type === 'attributes') scan(record.target);
          else {
            record.addedNodes.forEach(scan);
            record.removedNodes.forEach(scan);
          }
        });
      });
    }
    observer.disconnect();
    const roots = new Set([
      document.querySelector('#main'),
      document.querySelector('#lightbox') || lightboxImage?.parentElement
    ]);
    roots.forEach(element => {
      if (element) observer.observe(element, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-lrs-allow-image-save']
      });
    });
  }

  function deterSave(event) {
    if (!enabled()) return;
    // Only the image target is affected: link, text and keyboard menus stay native.
    const image = event.target;
    if (image instanceof HTMLImageElement && isPhoto(image)) {
      protect(image);
      event.preventDefault();
    }
  }

  document.addEventListener('contextmenu', deterSave, true);
  document.addEventListener('dragstart', deterSave, true);
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.LRSPhotoProtection = {init};
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  } else init();
})();
